<template>
  <div class="no-auth">
    <a-result status="403" title="403" sub-title="非常抱歉，暂无权限访问">
      <template #extra>
        <a-button type="primary" @click="returnPage">回到首页</a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
  export default {
    name: 'NoAuth',
    methods: {
      returnPage() {
        this.$store.commit('setRedirectUrl', null);
        this.$router.replace('/');
      }
    },
  }
</script>

<style lang="less" scoped>

</style>